<template>
	<div class="container mt-5 custom-container">
		<div class="row">
			<div class="col-12">
				<div class="card">
					<!-- Header Section -->
					<div class="row">
						<div class="col-md-4">
							<img
								:src="
									urlGenerator(
										'images/logo_clc_new_landscape.png'
									)
								"
								alt="logo"
								width="200"
								class="mt-3 ml-3"
							/>
						</div>
						<div class="col-md-4"></div>
						<div class="col-md-4 text-right pr-5" >
							<h2 class="mt-3 display-5 " style="font-family: initial;">
								FEES NOTICE
							</h2>
							<span>
								No. FN-CLC PH/VI/2025/20125
							</span>
						</div>
					</div>

					<!-- Body Section -->
					<div class="card-body">
						
						<div class="row">
							<div class="col-md-12">
								<table class="table table-sm table-bordered table-invoice-header">
									<tr>
										<th class="text-center">Virtual Account Number</th>
										<th class="text-center">Print Date</ht>
										<th class="text-center">Due Date</th>
										<th class="text-center">Payment Due (Rp)</th>
									</tr>
									<tr>
										<td class="text-center">
											{{
												invoiceData.bank_account_id
													? invoiceData
															.bank_account_id
															.bank_id
															.bank_name
													: ""
											}}
											:
											{{
												invoiceData.bank_account_id
													? invoiceData.bank_account_id.bank_account_virtual_no.replace("Edited", "")
													: ""
											}}

										</td>
										<td class="text-center">
											{{
												new Date(this.feesNoticeHeaderData.print_date).toLocaleDateString('en-GB', {
												weekday: 'short',
												day: '2-digit',
												month: 'short',
												year: 'numeric'
												})
											}}
										</td>
										<td class="text-center">
											{{
												new Date(this.feesNoticeHeaderData.due_date).toLocaleDateString('en-GB', {
												weekday: 'short',
												day: '2-digit',
												month: 'short',
												year: 'numeric'
												})
											}}
										</td>
										<td class="text-center">
											{{
												this.feesNoticeHeaderData
													.sub_total
											}}
										</td>
									</tr>
								</table>

							</div>
						</div>
						<div class="row ml-4">
							<div class="col-md-6">
								<table class=" table-sm ">
									<tr>
										<td width="35%">Student Name</td>
										<td width="10%">:</td>
										<td >
											{{
												this.feesNoticeHeaderData
													.customer_name
											}}
										</td>
									</tr>
									<tr>
										<td width="35%">Term Period</td>
										<td width="10%">:</td>
										<td >
											<span v-if="formattedDateRange">
												{{
													formattedDateRange 
												}}
											</span>
										</td>
									</tr>
								</table>
							</div>
							<div class="col-md-6" >
								<table class=" table-sm ">
									<tr>
										<td width="50%">Class Package</td>
										<td width="10%">:</td>
										<td>
											<span  v-if="studyInformationData.length ">{{ studyInformationData[0].schedule_recommendation_id.course_id.course_name }}</span>
										</td>
									</tr>
									<tr>
										<td width="50%">Product</td>
										<td width="10%">:</td>
										<td>
											<span  v-if="studyInformationData.length ">{{ studyInformationData[0].schedule_recommendation_id.product_id.name }}</span>
										</td>
									</tr>
								</table>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="card p-3 mt-4 mb-1 card-billing">
									<div class="row">
										<div class="col-md-12" align="center">
											<div>BILLING STATEMENT</div>
											<table class="table-sm table-billing" >
												<thead>
													<tr>
														<th class="text-center">Posting Date</th>
														<th class="text-center">Description</th>
														<th class="text-center">Amount (Rp)</th>
													</tr>
												</thead>
												<tbody>
													<!-- Repeat for each fee detail -->
													<tr
														v-for="(
															data, index
														) in feesNoticeDetailsData"
														:key="index"
													>
														<td class="text-center">{{ data.date }}</td>
														<td class="pl-3"
															:style="
																data.product_id.name ==
																	'Total Charges' ||
																data.product_id.name ==
																	'Total Deductions' ||
																data.product_id.name ==
																	'Balance Due' ||
																data.product_id.name ==
																	'Admin Fee' ||
																data.product_id.name
																	.toLowerCase()
																	.includes('tax') ||
																data.product_id.name ==
																	'Grand Total'
																	? 'text-align: right; font-weight: bold'
																	: ''
															"
														>
															{{ data.product_id.name }}
														</td>
														<td style="text-align: right">
															{{ data.debit }}
														</td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="card p-3 mt-4 mb-4 card-early-bird">
									<span style="white-space: nowrap;">
										Early Bird: Save <span class="text-primary">Rp500,000</span> on your course fee for payment before Fri, 11 Jul 2025
									</span>
								</div>
							</div>
						</div>

						<div class="row">
							<!-- List Notes -->
							<div class="col-md-9">
								<b><p>Note:</p></b>
								<ul class="strip-list">
									<li data-style="star">
										Early Bird Price is updated automatically in Virtual Account.
									</li>
									<li>
										Material fee is payable every term.
									</li>
									<li>
										Student receives materials one week after all fees are fully paid.
									</li>
									<li>
										All fees are NON-REFUNDABLE / NON-TRANSFERABLE.
									</li>
									<li>
										Course fee varies based on product name and/or class level.
									</li>
									<li>
										Full payment must be received before start date or student account will be deactivated.
									</li>
									<li>
										Student account can be reactivated upon request and is subject to CLC's approval.
									</li>
									<li>
										Processing fee applies in reactivating student account and must be paid before student joins the class.
									</li>
									<li>
										For enquiries, please call CLC at WhatsApp 0896 111 777 30.
									</li>
								</ul>
							</div>
							<!-- Payment To -->
							<div class="col-md-32">
								<div class="row">
									<div class="col-md-12 text-center box-va p-3">
										<span>Please use</span>
										<br>
										<span style="font-weight:600;">Virtual Account</span>
										<br>
										<span>to make payment</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { urlGenerator } from "../../../../../../../../Helpers/AxiosHelper";

export default {
	name: "InvoiceProcess",
	data() {
		return {
			urlGenerator,
			id: null,
			invoiceData: {},
			studyInformationData: [],
			feesNoticeDetailsData: [],
			feesNoticeHeaderData: [],
			bankLogoHtml: "",
		};
	},
	created() {
		let url = window.location.href;
		this.id = parseInt(url.split("/").slice(-1)[0].split("?")[0]);

		this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				let [
					invoiceDataResponse,
					studyInformationResponse,
					feesNoticeDetailsResponse,
					feesNoticeHeaderResponse,
				] = await Promise.all([
					axios.get(`/transaction/invoice/${this.id}`),
					axios.get(
						`/transaction/invoice-item?invoice_id=${this.id}`
					),
					axios.get(
						`/transaction/invoice/${this.id}/fee-notice-details`
					),
					axios.get(
						`/transaction/invoice/${this.id}/fee-notice-header`
					),
				]);

				this.invoiceData = invoiceDataResponse.data;
				this.studyInformationData = studyInformationResponse.data.data;
				this.feesNoticeDetailsData =
					feesNoticeDetailsResponse.data.data;
				this.feesNoticeHeaderData = feesNoticeHeaderResponse.data;

				this.bankLogoHtml = this.invoiceData.bank_account_id?.bank_id
					? `<img src="${this.urlGenerator(
							this.invoiceData.bank_account_id.bank_id.bank_logo
					  )}" alt="logo" width="100" />`
					: `<img src="https://dummyimage.com/150x100/000/fff&text=no-bank-logo" alt="logo" width="100" />`;

				// Custom sorting function
				this.feesNoticeDetailsData.sort((a, b) => {
					if (a.credit === "0.00" && b.credit !== "0.00") {
						return -1; // Place a before b if a has credit 0 and b doesn't
					} else if (a.credit !== "0.00" && b.credit === "0.00") {
						return 1; // Place b before a if b has credit 0 and a doesn't
					} else if (a.debit === "0.00" && b.debit !== "0.00") {
						return -1; // If both have credit 0, place a before b if a has debit 0 and b doesn't
					} else if (a.debit !== "0.00" && b.debit === "0.00") {
						return 1; // If both have credit 0, place b before a if b has debit 0 and a doesn't
					} else {
						return 0; // Maintain the current order if both have non-zero values for credit and debit
					}
				});

				// add total charges and total credits to this.feesNoticeDetailsData
				let totalChargesObj = {
					balance: 0,
					credit: 0,
					debit: this.invoiceData.total_charges,
					product_id: {
						name: "Total Charges",
					},
					qty: 1,
				};
				// count total data with credit = 0
				let totalCredit0 = this.feesNoticeDetailsData.filter(
					(data) => data.credit == 0
				).length;
				// insert total charges after total data with credit = 0
				this.feesNoticeDetailsData.splice(
					totalCredit0,
					0,
					totalChargesObj
				);

				// add total deductions to this.feesNoticeDetailsData
				let totalDeductionsObj = {
					balance: 0,
					credit:
						this.invoiceData.total_deductions != 0
							? this.invoiceData.total_deductions
							: "",
					debit: 0,
					product_id: {
						name: "Total Deductions",
					},
					qty: this.invoiceData.total_deductions != 0 ? 1 : "",
				};
				let totalDebit0 =
					this.feesNoticeDetailsData.filter((data) => data.debit == 0)
						.length + totalCredit0;
				if (this.invoiceData.total_deductions == 0) {
					totalDebit0 = this.feesNoticeDetailsData.findIndex(
						(data) => data.product_id?.name == "Total Charges"
					);
					// insert total deductions after total charges
					this.feesNoticeDetailsData.splice(
						totalDebit0 + 1,
						0,
						totalDeductionsObj
					);
				} else {
					// insert total deductions after total data with debit = 0
					this.feesNoticeDetailsData.splice(
						totalDebit0 + 1,
						0,
						totalDeductionsObj
					);
				}

				// loop this.feesNoticeDetailsData and console.log index, debit and credit
				// for (let i = 0; i < this.feesNoticeDetailsData.length; i++) {
				// 	console.log(i, this.feesNoticeDetailsData[i].product_id?.name, this.feesNoticeDetailsData[i].debit, this.feesNoticeDetailsData[i].credit);
				// }
				// console.log(this.feesNoticeDetailsData.filter((data) => data.credit == 0).length)
				// console.log(this.feesNoticeDetailsData.filter((data) => data.debit == 0).length)
				// console.log(this.feesNoticeDetailsData.findIndex((data) => data.product_id?.name == 'Total Charges'))

				// add balance due to this.feesNoticeDetailsData
				let balanceDueObj = {
					balance:
						this.invoiceData.total_charges -
						this.invoiceData.total_deductions,
					credit: 0,
					debit: 0,
					product_id: {
						name: "Balance Due",
					},
					qty: 1,
				};
				this.feesNoticeDetailsData.push(balanceDueObj);

				// add tax to this.feesNoticeDetailsData
				let taxObj = {
					balance: 0,
					credit: 0,
					debit: this.invoiceData.vat_amount,
					product_id: {
						name:
							"Tax (" +
							parseFloat(this.invoiceData.vat_percent) +
							"%)",
					},
					qty: 1,
				};
				this.feesNoticeDetailsData.push(taxObj);

				// add admin fee to this.feesNoticeDetailsData
				let adminFeeObj = {
					balance: 0,
					credit: 0,
					debit: parseFloat(this.invoiceData.admin_fee),
					product_id: {
						name: "Admin Fee",
					},
					qty: 1,
				};
				this.feesNoticeDetailsData.push(adminFeeObj);

				// add grand total to this.feesNoticeDetailsData
				let grandTotalObj = {
					balance: this.invoiceData.grand_total,
					credit: 0,
					debit: 0,
					product_id: {
						name: "Grand Total",
					},
					qty: 1,
				};
				this.feesNoticeDetailsData.push(grandTotalObj);

				this.feesNoticeDetailsData.forEach((data) => {
					if (
						(data.debit != 0 || data.credit != 0) &&
						data.balance != 0
					) {
						data.balance = 0;
					}
					data.debit =
						data.debit != 0 ? this.formattedIDR(data.debit) : "";
					data.credit =
						data.credit != 0 ? this.formattedIDR(data.credit) : "";
					data.balance =
						data.balance != 0
							? this.formattedIDR(data.balance)
							: "";
				});

				this.feesNoticeHeaderData.sub_total = this.formattedIDR(
					this.invoiceData.grand_total
				);
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		formattedIDR(value) {
			let val = (value / 1).toFixed(0).replace(".", ",");
			return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
		},
	},
	computed: {
		formattedDateRange() {
			if (
				!this.feesNoticeHeaderData?.date_start ||
				!this.feesNoticeHeaderData?.date_end
			) {
				return ''; // atau return null / "-"
			}

			const start = new Date(this.feesNoticeHeaderData.date_start);
			const end = new Date(this.feesNoticeHeaderData.date_end);

			if (isNaN(start.getTime()) || isNaN(end.getTime())) {
				return ''; // Tangani jika date string invalid
			}

			const startDay = String(start.getDate()).padStart(2, '0');
			const startMonth = start.toLocaleDateString('en-GB', { month: 'short' });
			const startYear = start.getFullYear();

			const endDay = String(end.getDate()).padStart(2, '0');
			const endMonth = end.toLocaleDateString('en-GB', { month: 'short' });
			const endYear = end.getFullYear();

			if (startYear === endYear) {
				return `${startDay} ${startMonth} - ${endDay} ${endMonth} ${endYear}`;
			} else {
				return `${startDay} ${startMonth} ${startYear} - ${endDay} ${endMonth} ${endYear}`;
			}
		}
	},
	watch: {},
};
</script>

<style scoped>
.bold-primary-header {
	background-color: #0056b3; /* A deeper shade of primary color */
	color: white;
}

.regular-primary-header {
	background-color: #007bff; /* Bootstrap's standard primary color */
	color: white;
	text-align: center;
	vertical-align: middle;
}
.regular-primary-header-fees-not-price {
	background-color: #007bff; /* Bootstrap's standard primary color */
	color: white;
	text-align: left;
	vertical-align: middle;
}
.regular-primary-header-fees-price {
	background-color: #007bff; /* Bootstrap's standard primary color */
	color: white;
	text-align: right;
	vertical-align: middle;
}
.custom-container {
	max-width: 900px; /* Adjust the value to your desired container width */
	margin: 0 auto; /* Center the container on the page */
}

.bigger-text {
	font-size: 26px;
	text-align: center;
	font-weight: bold;
}

.smaller-text {
	font-size: 18px;
	text-align: center;
}
.table-invoice-header th{
	background: #d0d0d0;
	border: 1px solid black !important;
	color:black;
	font-weight: 400;
}
.table-invoice-header td{
	border: 1px solid black !important;
	color:black;
}
.card-billing{
	border: 1px solid;
	border-radius: 15px;
}
.table-billing{
	width: 100%;
}
.table-billing th{
	background: #d0d0d0;
	color: black;
	font-weight: 400;
  	border: 3px solid white;
}
.strip-list {
  list-style-type: none;
  padding-left: 0;
}

.strip-list li::before {
  content: "- ";
  margin-right: 4px;
}
.star-list {
  list-style-type: none;
  padding-left: 0;
}

.star-list li::before {
  content: "* ";
  margin-right: 4px;
}
li{
	white-space: nowrap;
}
li[data-style="star"]::before {
	content: "* ";
}
.box-va{
	color: black;
	border: 2px solid red;
}
.card-early-bird{
	background: #d0d0d0;
	font-weight: bold;
	font-size: 20px;
}
</style>
